import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "keep_track_users",
    object: "keep_track_user",
    header: [
      { text: "User", value: "user_id"},
      { text: "Date", value: "createdAt"},
      { text: "Discount", value: "discount" },
      { text: "Order id", value: "id" ,sortable: false},
      { text: "Store", value: "store_id" ,sortable: false},
      { text: "Company", value: "company_id" ,sortable: false},
    ],
    users_discount: [],
  },
  mutations: {
    ...genericStore.mutations,
    update_users_discount(state, data) {
      state.users_discount = data;
    },
  },
  actions: {
    ...genericStore.actions,
    get_users_discount({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(config.api_url + "get_users_discount")
          .then(response => {
            commit("update_users_discount", response.data);
          })
          .catch(err => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters
  }
};
